import { IDocs } from "./MyDocuments.model";

export function getMyDocumentsLiterals(t: any) {
  return {
    title: t("myDocuments.title"),
    description: t("myDocuments.description"),
    validated: t("literals.validated"),
    lapsed: t("literals.lapsed"),
  };
}

export function getCards(t: any) {
  return [
    {
      id: t("myDocuments.cards.0.id"),
      title: t("myDocuments.cards.0.title"),
      descriptionText: t("myDocuments.cards.0.descriptionText"),
      url: t("myDocuments.cards.0.id"),
      iconType: "checkError",
    },
    {
      id: t("myDocuments.cards.1.id"),
      title: t("myDocuments.cards.1.title"),
      descriptionText: t("myDocuments.cards.1.descriptionText"),
      url: t("myDocuments.cards.1.id"),
      iconType: "checkError",
    },
  ];
}

export function dateFormatter(date: string) {
  const [year, month, day] = date.split("-");

  // Step 2: Format the date to DD/MM/YYYY
  return `${day}/${month}/${year}`;
}

export function validateDocs(docs: IDocs[]) {
  // Step 1: Check if the array is empty
  let resultUpload = true,
    isExpired = false,
    result = true;

  if (docs.length === 0 || docs.length === 1) {
    resultUpload = false;
  }

  // Step 2: Check if all documents have isExpired as true
  isExpired = docs.some((doc) => doc.isExpired);

  if (resultUpload === false) {
    result = false;
  } else if (resultUpload === true) {
    if (isExpired === false) {
      result = true;
    } else {
      result = false;
    }
  }

  return result;
}
